/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query'

import type {
    GetRequestStripeCustomerExistsParams,
    GetRequestStripePaymentMethodParams,
    GetRequestStripeProductsParams,
    GetRequestStripePurchaseValidatePurchaseBySubscriptionIdParams,
    GetRequestStripeSubscriptionsParams,
    HTTPValidationErrorDTO,
    MessageResponseDTO,
    PaymentInfoResponseDTO,
    PostRequestStripeCreateCustomerParams,
    PostRequestStripeCreateSetupIntentParams,
    PostRequestStripeFinishSetupIntentParams,
    PostRequestStripePurchaseCancelBySubscriptionIdParams,
    PostRequestStripePurchaseReactivateBySubscriptionIdParams,
    PostRequestStripeV1Purchase200,
    PostRequestStripeV1PurchaseParams,
    PutRequestStripeV1Purchase200,
    PutRequestStripeV1PurchaseParams,
    StripeProductListResponseDTO,
    StripeSetupIntentCreateResponseDTO,
    StripeSubscriptionResponseDTO,
} from '../../model'

import { customInstance } from '../../../customInstance'
import type { ErrorType } from '../../../customInstance'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * A list of available web store/stripe products
 * @summary Get Stripe Products
 */
export const getRequestStripeProducts = (
    params: GetRequestStripeProductsParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<StripeProductListResponseDTO>(
        { url: `/stripe_products`, method: 'GET', params, signal },
        options,
    )
}

export const getGetRequestStripeProductsQueryKey = (
    params?: GetRequestStripeProductsParams,
) => {
    return [`/stripe_products`, ...(params ? [params] : [])] as const
}

export const getGetRequestStripeProductsQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestStripeProducts>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestStripeProductsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestStripeProducts>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ?? getGetRequestStripeProductsQueryKey(params)

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestStripeProducts>>
    > = ({ signal }) => getRequestStripeProducts(params, requestOptions, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestStripeProducts>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestStripeProductsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestStripeProducts>>
>
export type GetRequestStripeProductsQueryError =
    ErrorType<HTTPValidationErrorDTO>

export function useGetRequestStripeProducts<
    TData = Awaited<ReturnType<typeof getRequestStripeProducts>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestStripeProductsParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestStripeProducts>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestStripeProducts>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestStripeProducts>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestStripeProducts<
    TData = Awaited<ReturnType<typeof getRequestStripeProducts>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestStripeProductsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestStripeProducts>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestStripeProducts>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestStripeProducts>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestStripeProducts<
    TData = Awaited<ReturnType<typeof getRequestStripeProducts>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestStripeProductsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestStripeProducts>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Get Stripe Products
 */

export function useGetRequestStripeProducts<
    TData = Awaited<ReturnType<typeof getRequestStripeProducts>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestStripeProductsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestStripeProducts>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions = getGetRequestStripeProductsQueryOptions(
        params,
        options,
    )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * Validate if subscription is paid successfully
 * @summary Validate Purchase Status
 */
export const getRequestStripePurchaseValidatePurchaseBySubscriptionId = (
    subscriptionId: string,
    params: GetRequestStripePurchaseValidatePurchaseBySubscriptionIdParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        {
            url: `/stripe_purchase/${encodeURIComponent(String(subscriptionId))}/validate_purchase`,
            method: 'GET',
            params,
            signal,
        },
        options,
    )
}

export const getGetRequestStripePurchaseValidatePurchaseBySubscriptionIdQueryKey =
    (
        subscriptionId?: string,
        params?: GetRequestStripePurchaseValidatePurchaseBySubscriptionIdParams,
    ) => {
        return [
            `/stripe_purchase/${subscriptionId}/validate_purchase`,
            ...(params ? [params] : []),
        ] as const
    }

export const getGetRequestStripePurchaseValidatePurchaseBySubscriptionIdQueryOptions =
    <
        TData = Awaited<
            ReturnType<
                typeof getRequestStripePurchaseValidatePurchaseBySubscriptionId
            >
        >,
        TError = ErrorType<void | HTTPValidationErrorDTO>,
    >(
        subscriptionId: string,
        params: GetRequestStripePurchaseValidatePurchaseBySubscriptionIdParams,
        options?: {
            query?: Partial<
                UseQueryOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestStripePurchaseValidatePurchaseBySubscriptionId
                        >
                    >,
                    TError,
                    TData
                >
            >
            request?: SecondParameter<typeof customInstance>
        },
    ) => {
        const { query: queryOptions, request: requestOptions } = options ?? {}

        const queryKey =
            queryOptions?.queryKey ??
            getGetRequestStripePurchaseValidatePurchaseBySubscriptionIdQueryKey(
                subscriptionId,
                params,
            )

        const queryFn: QueryFunction<
            Awaited<
                ReturnType<
                    typeof getRequestStripePurchaseValidatePurchaseBySubscriptionId
                >
            >
        > = ({ signal }) =>
            getRequestStripePurchaseValidatePurchaseBySubscriptionId(
                subscriptionId,
                params,
                requestOptions,
                signal,
            )

        return {
            queryKey,
            queryFn,
            enabled: !!subscriptionId,
            ...queryOptions,
        } as UseQueryOptions<
            Awaited<
                ReturnType<
                    typeof getRequestStripePurchaseValidatePurchaseBySubscriptionId
                >
            >,
            TError,
            TData
        > & { queryKey: DataTag<QueryKey, TData, TError> }
    }

export type GetRequestStripePurchaseValidatePurchaseBySubscriptionIdQueryResult =
    NonNullable<
        Awaited<
            ReturnType<
                typeof getRequestStripePurchaseValidatePurchaseBySubscriptionId
            >
        >
    >
export type GetRequestStripePurchaseValidatePurchaseBySubscriptionIdQueryError =
    ErrorType<void | HTTPValidationErrorDTO>

export function useGetRequestStripePurchaseValidatePurchaseBySubscriptionId<
    TData = Awaited<
        ReturnType<
            typeof getRequestStripePurchaseValidatePurchaseBySubscriptionId
        >
    >,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    subscriptionId: string,
    params: GetRequestStripePurchaseValidatePurchaseBySubscriptionIdParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestStripePurchaseValidatePurchaseBySubscriptionId
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestStripePurchaseValidatePurchaseBySubscriptionId
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getRequestStripePurchaseValidatePurchaseBySubscriptionId
                        >
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestStripePurchaseValidatePurchaseBySubscriptionId<
    TData = Awaited<
        ReturnType<
            typeof getRequestStripePurchaseValidatePurchaseBySubscriptionId
        >
    >,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    subscriptionId: string,
    params: GetRequestStripePurchaseValidatePurchaseBySubscriptionIdParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestStripePurchaseValidatePurchaseBySubscriptionId
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestStripePurchaseValidatePurchaseBySubscriptionId
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getRequestStripePurchaseValidatePurchaseBySubscriptionId
                        >
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestStripePurchaseValidatePurchaseBySubscriptionId<
    TData = Awaited<
        ReturnType<
            typeof getRequestStripePurchaseValidatePurchaseBySubscriptionId
        >
    >,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    subscriptionId: string,
    params: GetRequestStripePurchaseValidatePurchaseBySubscriptionIdParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestStripePurchaseValidatePurchaseBySubscriptionId
                    >
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Validate Purchase Status
 */

export function useGetRequestStripePurchaseValidatePurchaseBySubscriptionId<
    TData = Awaited<
        ReturnType<
            typeof getRequestStripePurchaseValidatePurchaseBySubscriptionId
        >
    >,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    subscriptionId: string,
    params: GetRequestStripePurchaseValidatePurchaseBySubscriptionIdParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestStripePurchaseValidatePurchaseBySubscriptionId
                    >
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions =
        getGetRequestStripePurchaseValidatePurchaseBySubscriptionIdQueryOptions(
            subscriptionId,
            params,
            options,
        )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * Reactive a cancelled subscription while it is still active

 * @summary Post Stripe Purchase Cancel
 */
export const postRequestStripePurchaseCancelBySubscriptionId = (
    subscriptionId: string,
    params: PostRequestStripePurchaseCancelBySubscriptionIdParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        {
            url: `/stripe_purchase/${encodeURIComponent(String(subscriptionId))}/cancel`,
            method: 'POST',
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestStripePurchaseCancelBySubscriptionIdMutationOptions =
    <
        TError = ErrorType<void | HTTPValidationErrorDTO>,
        TContext = unknown,
    >(options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof postRequestStripePurchaseCancelBySubscriptionId
                >
            >,
            TError,
            {
                subscriptionId: string
                params: PostRequestStripePurchaseCancelBySubscriptionIdParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    }): UseMutationOptions<
        Awaited<
            ReturnType<typeof postRequestStripePurchaseCancelBySubscriptionId>
        >,
        TError,
        {
            subscriptionId: string
            params: PostRequestStripePurchaseCancelBySubscriptionIdParams
        },
        TContext
    > => {
        const mutationKey = ['postRequestStripePurchaseCancelBySubscriptionId']
        const { mutation: mutationOptions, request: requestOptions } = options
            ? options.mutation &&
              'mutationKey' in options.mutation &&
              options.mutation.mutationKey
                ? options
                : { ...options, mutation: { ...options.mutation, mutationKey } }
            : { mutation: { mutationKey }, request: undefined }

        const mutationFn: MutationFunction<
            Awaited<
                ReturnType<
                    typeof postRequestStripePurchaseCancelBySubscriptionId
                >
            >,
            {
                subscriptionId: string
                params: PostRequestStripePurchaseCancelBySubscriptionIdParams
            }
        > = (props) => {
            const { subscriptionId, params } = props ?? {}

            return postRequestStripePurchaseCancelBySubscriptionId(
                subscriptionId,
                params,
                requestOptions,
            )
        }

        return { mutationFn, ...mutationOptions }
    }

export type PostRequestStripePurchaseCancelBySubscriptionIdMutationResult =
    NonNullable<
        Awaited<
            ReturnType<typeof postRequestStripePurchaseCancelBySubscriptionId>
        >
    >

export type PostRequestStripePurchaseCancelBySubscriptionIdMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Post Stripe Purchase Cancel
 */
export const usePostRequestStripePurchaseCancelBySubscriptionId = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof postRequestStripePurchaseCancelBySubscriptionId
                >
            >,
            TError,
            {
                subscriptionId: string
                params: PostRequestStripePurchaseCancelBySubscriptionIdParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestStripePurchaseCancelBySubscriptionId>>,
    TError,
    {
        subscriptionId: string
        params: PostRequestStripePurchaseCancelBySubscriptionIdParams
    },
    TContext
> => {
    const mutationOptions =
        getPostRequestStripePurchaseCancelBySubscriptionIdMutationOptions(
            options,
        )

    return useMutation(mutationOptions, queryClient)
}
/**
 * Reactive a cancelled subscription while it is still active

 * @summary Post Stripe Purchase Reactivate
 */
export const postRequestStripePurchaseReactivateBySubscriptionId = (
    subscriptionId: string,
    params: PostRequestStripePurchaseReactivateBySubscriptionIdParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        {
            url: `/stripe_purchase/${encodeURIComponent(String(subscriptionId))}/reactivate`,
            method: 'POST',
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestStripePurchaseReactivateBySubscriptionIdMutationOptions =
    <
        TError = ErrorType<void | HTTPValidationErrorDTO>,
        TContext = unknown,
    >(options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof postRequestStripePurchaseReactivateBySubscriptionId
                >
            >,
            TError,
            {
                subscriptionId: string
                params: PostRequestStripePurchaseReactivateBySubscriptionIdParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    }): UseMutationOptions<
        Awaited<
            ReturnType<
                typeof postRequestStripePurchaseReactivateBySubscriptionId
            >
        >,
        TError,
        {
            subscriptionId: string
            params: PostRequestStripePurchaseReactivateBySubscriptionIdParams
        },
        TContext
    > => {
        const mutationKey = [
            'postRequestStripePurchaseReactivateBySubscriptionId',
        ]
        const { mutation: mutationOptions, request: requestOptions } = options
            ? options.mutation &&
              'mutationKey' in options.mutation &&
              options.mutation.mutationKey
                ? options
                : { ...options, mutation: { ...options.mutation, mutationKey } }
            : { mutation: { mutationKey }, request: undefined }

        const mutationFn: MutationFunction<
            Awaited<
                ReturnType<
                    typeof postRequestStripePurchaseReactivateBySubscriptionId
                >
            >,
            {
                subscriptionId: string
                params: PostRequestStripePurchaseReactivateBySubscriptionIdParams
            }
        > = (props) => {
            const { subscriptionId, params } = props ?? {}

            return postRequestStripePurchaseReactivateBySubscriptionId(
                subscriptionId,
                params,
                requestOptions,
            )
        }

        return { mutationFn, ...mutationOptions }
    }

export type PostRequestStripePurchaseReactivateBySubscriptionIdMutationResult =
    NonNullable<
        Awaited<
            ReturnType<
                typeof postRequestStripePurchaseReactivateBySubscriptionId
            >
        >
    >

export type PostRequestStripePurchaseReactivateBySubscriptionIdMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Post Stripe Purchase Reactivate
 */
export const usePostRequestStripePurchaseReactivateBySubscriptionId = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof postRequestStripePurchaseReactivateBySubscriptionId
                >
            >,
            TError,
            {
                subscriptionId: string
                params: PostRequestStripePurchaseReactivateBySubscriptionIdParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<
        ReturnType<typeof postRequestStripePurchaseReactivateBySubscriptionId>
    >,
    TError,
    {
        subscriptionId: string
        params: PostRequestStripePurchaseReactivateBySubscriptionIdParams
    },
    TContext
> => {
    const mutationOptions =
        getPostRequestStripePurchaseReactivateBySubscriptionIdMutationOptions(
            options,
        )

    return useMutation(mutationOptions, queryClient)
}
/**
 * Get the web store/stripe payment details of a user
 * @summary Get Stripe Payment Method
 */
export const getRequestStripePaymentMethod = (
    params: GetRequestStripePaymentMethodParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<PaymentInfoResponseDTO>(
        { url: `/stripe_payment_method`, method: 'GET', params, signal },
        options,
    )
}

export const getGetRequestStripePaymentMethodQueryKey = (
    params?: GetRequestStripePaymentMethodParams,
) => {
    return [`/stripe_payment_method`, ...(params ? [params] : [])] as const
}

export const getGetRequestStripePaymentMethodQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestStripePaymentMethod>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    params: GetRequestStripePaymentMethodParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestStripePaymentMethod>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ??
        getGetRequestStripePaymentMethodQueryKey(params)

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestStripePaymentMethod>>
    > = ({ signal }) =>
        getRequestStripePaymentMethod(params, requestOptions, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestStripePaymentMethod>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestStripePaymentMethodQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestStripePaymentMethod>>
>
export type GetRequestStripePaymentMethodQueryError =
    ErrorType<void | HTTPValidationErrorDTO>

export function useGetRequestStripePaymentMethod<
    TData = Awaited<ReturnType<typeof getRequestStripePaymentMethod>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    params: GetRequestStripePaymentMethodParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestStripePaymentMethod>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestStripePaymentMethod>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestStripePaymentMethod>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestStripePaymentMethod<
    TData = Awaited<ReturnType<typeof getRequestStripePaymentMethod>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    params: GetRequestStripePaymentMethodParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestStripePaymentMethod>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestStripePaymentMethod>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestStripePaymentMethod>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestStripePaymentMethod<
    TData = Awaited<ReturnType<typeof getRequestStripePaymentMethod>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    params: GetRequestStripePaymentMethodParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestStripePaymentMethod>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Get Stripe Payment Method
 */

export function useGetRequestStripePaymentMethod<
    TData = Awaited<ReturnType<typeof getRequestStripePaymentMethod>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    params: GetRequestStripePaymentMethodParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestStripePaymentMethod>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions = getGetRequestStripePaymentMethodQueryOptions(
        params,
        options,
    )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * @summary Put Stripe V1 Purchase
 */
export const putRequestStripeV1Purchase = (
    params: PutRequestStripeV1PurchaseParams,
    options?: SecondParameter<typeof customInstance>,
) => {
    return customInstance<PutRequestStripeV1Purchase200>(
        { url: `/stripe/v1/purchase`, method: 'PUT', params },
        options,
    )
}

export const getPutRequestStripeV1PurchaseMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof putRequestStripeV1Purchase>>,
        TError,
        { params: PutRequestStripeV1PurchaseParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof putRequestStripeV1Purchase>>,
    TError,
    { params: PutRequestStripeV1PurchaseParams },
    TContext
> => {
    const mutationKey = ['putRequestStripeV1Purchase']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof putRequestStripeV1Purchase>>,
        { params: PutRequestStripeV1PurchaseParams }
    > = (props) => {
        const { params } = props ?? {}

        return putRequestStripeV1Purchase(params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PutRequestStripeV1PurchaseMutationResult = NonNullable<
    Awaited<ReturnType<typeof putRequestStripeV1Purchase>>
>

export type PutRequestStripeV1PurchaseMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Put Stripe V1 Purchase
 */
export const usePutRequestStripeV1Purchase = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof putRequestStripeV1Purchase>>,
            TError,
            { params: PutRequestStripeV1PurchaseParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof putRequestStripeV1Purchase>>,
    TError,
    { params: PutRequestStripeV1PurchaseParams },
    TContext
> => {
    const mutationOptions =
        getPutRequestStripeV1PurchaseMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Post Stripe Purchase New
 */
export const postRequestStripeV1Purchase = (
    params: PostRequestStripeV1PurchaseParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<PostRequestStripeV1Purchase200>(
        { url: `/stripe/v1/purchase`, method: 'POST', params, signal },
        options,
    )
}

export const getPostRequestStripeV1PurchaseMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestStripeV1Purchase>>,
        TError,
        { params: PostRequestStripeV1PurchaseParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestStripeV1Purchase>>,
    TError,
    { params: PostRequestStripeV1PurchaseParams },
    TContext
> => {
    const mutationKey = ['postRequestStripeV1Purchase']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestStripeV1Purchase>>,
        { params: PostRequestStripeV1PurchaseParams }
    > = (props) => {
        const { params } = props ?? {}

        return postRequestStripeV1Purchase(params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestStripeV1PurchaseMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestStripeV1Purchase>>
>

export type PostRequestStripeV1PurchaseMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Post Stripe Purchase New
 */
export const usePostRequestStripeV1Purchase = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestStripeV1Purchase>>,
            TError,
            { params: PostRequestStripeV1PurchaseParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestStripeV1Purchase>>,
    TError,
    { params: PostRequestStripeV1PurchaseParams },
    TContext
> => {
    const mutationOptions =
        getPostRequestStripeV1PurchaseMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Post Create Setup Intent
 */
export const postRequestStripeCreateSetupIntent = (
    params: PostRequestStripeCreateSetupIntentParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<StripeSetupIntentCreateResponseDTO>(
        { url: `/stripe/create_setup_intent`, method: 'POST', params, signal },
        options,
    )
}

export const getPostRequestStripeCreateSetupIntentMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestStripeCreateSetupIntent>>,
        TError,
        { params: PostRequestStripeCreateSetupIntentParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestStripeCreateSetupIntent>>,
    TError,
    { params: PostRequestStripeCreateSetupIntentParams },
    TContext
> => {
    const mutationKey = ['postRequestStripeCreateSetupIntent']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestStripeCreateSetupIntent>>,
        { params: PostRequestStripeCreateSetupIntentParams }
    > = (props) => {
        const { params } = props ?? {}

        return postRequestStripeCreateSetupIntent(params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestStripeCreateSetupIntentMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestStripeCreateSetupIntent>>
>

export type PostRequestStripeCreateSetupIntentMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Post Create Setup Intent
 */
export const usePostRequestStripeCreateSetupIntent = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestStripeCreateSetupIntent>>,
            TError,
            { params: PostRequestStripeCreateSetupIntentParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestStripeCreateSetupIntent>>,
    TError,
    { params: PostRequestStripeCreateSetupIntentParams },
    TContext
> => {
    const mutationOptions =
        getPostRequestStripeCreateSetupIntentMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Post Finish Setup Intent
 */
export const postRequestStripeFinishSetupIntent = (
    params: PostRequestStripeFinishSetupIntentParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<MessageResponseDTO>(
        { url: `/stripe/finish_setup_intent`, method: 'POST', params, signal },
        options,
    )
}

export const getPostRequestStripeFinishSetupIntentMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestStripeFinishSetupIntent>>,
        TError,
        { params: PostRequestStripeFinishSetupIntentParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestStripeFinishSetupIntent>>,
    TError,
    { params: PostRequestStripeFinishSetupIntentParams },
    TContext
> => {
    const mutationKey = ['postRequestStripeFinishSetupIntent']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestStripeFinishSetupIntent>>,
        { params: PostRequestStripeFinishSetupIntentParams }
    > = (props) => {
        const { params } = props ?? {}

        return postRequestStripeFinishSetupIntent(params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestStripeFinishSetupIntentMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestStripeFinishSetupIntent>>
>

export type PostRequestStripeFinishSetupIntentMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Post Finish Setup Intent
 */
export const usePostRequestStripeFinishSetupIntent = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestStripeFinishSetupIntent>>,
            TError,
            { params: PostRequestStripeFinishSetupIntentParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestStripeFinishSetupIntent>>,
    TError,
    { params: PostRequestStripeFinishSetupIntentParams },
    TContext
> => {
    const mutationOptions =
        getPostRequestStripeFinishSetupIntentMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Get Customer Exists
 */
export const getRequestStripeCustomerExists = (
    params: GetRequestStripeCustomerExistsParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<MessageResponseDTO>(
        { url: `/stripe/customer_exists`, method: 'GET', params, signal },
        options,
    )
}

export const getGetRequestStripeCustomerExistsQueryKey = (
    params?: GetRequestStripeCustomerExistsParams,
) => {
    return [`/stripe/customer_exists`, ...(params ? [params] : [])] as const
}

export const getGetRequestStripeCustomerExistsQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestStripeCustomerExists>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestStripeCustomerExistsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestStripeCustomerExists>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ??
        getGetRequestStripeCustomerExistsQueryKey(params)

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestStripeCustomerExists>>
    > = ({ signal }) =>
        getRequestStripeCustomerExists(params, requestOptions, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestStripeCustomerExists>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestStripeCustomerExistsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestStripeCustomerExists>>
>
export type GetRequestStripeCustomerExistsQueryError =
    ErrorType<HTTPValidationErrorDTO>

export function useGetRequestStripeCustomerExists<
    TData = Awaited<ReturnType<typeof getRequestStripeCustomerExists>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestStripeCustomerExistsParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestStripeCustomerExists>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestStripeCustomerExists>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestStripeCustomerExists>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestStripeCustomerExists<
    TData = Awaited<ReturnType<typeof getRequestStripeCustomerExists>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestStripeCustomerExistsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestStripeCustomerExists>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestStripeCustomerExists>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestStripeCustomerExists>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestStripeCustomerExists<
    TData = Awaited<ReturnType<typeof getRequestStripeCustomerExists>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestStripeCustomerExistsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestStripeCustomerExists>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Get Customer Exists
 */

export function useGetRequestStripeCustomerExists<
    TData = Awaited<ReturnType<typeof getRequestStripeCustomerExists>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestStripeCustomerExistsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestStripeCustomerExists>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions = getGetRequestStripeCustomerExistsQueryOptions(
        params,
        options,
    )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * @summary Get Stripe Subscriptions
 */
export const getRequestStripeSubscriptions = (
    params: GetRequestStripeSubscriptionsParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<StripeSubscriptionResponseDTO>(
        { url: `/stripe/subscriptions`, method: 'GET', params, signal },
        options,
    )
}

export const getGetRequestStripeSubscriptionsQueryKey = (
    params?: GetRequestStripeSubscriptionsParams,
) => {
    return [`/stripe/subscriptions`, ...(params ? [params] : [])] as const
}

export const getGetRequestStripeSubscriptionsQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestStripeSubscriptions>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestStripeSubscriptionsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestStripeSubscriptions>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ??
        getGetRequestStripeSubscriptionsQueryKey(params)

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestStripeSubscriptions>>
    > = ({ signal }) =>
        getRequestStripeSubscriptions(params, requestOptions, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestStripeSubscriptions>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestStripeSubscriptionsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestStripeSubscriptions>>
>
export type GetRequestStripeSubscriptionsQueryError =
    ErrorType<HTTPValidationErrorDTO>

export function useGetRequestStripeSubscriptions<
    TData = Awaited<ReturnType<typeof getRequestStripeSubscriptions>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestStripeSubscriptionsParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestStripeSubscriptions>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestStripeSubscriptions>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestStripeSubscriptions>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestStripeSubscriptions<
    TData = Awaited<ReturnType<typeof getRequestStripeSubscriptions>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestStripeSubscriptionsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestStripeSubscriptions>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestStripeSubscriptions>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestStripeSubscriptions>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestStripeSubscriptions<
    TData = Awaited<ReturnType<typeof getRequestStripeSubscriptions>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestStripeSubscriptionsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestStripeSubscriptions>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Get Stripe Subscriptions
 */

export function useGetRequestStripeSubscriptions<
    TData = Awaited<ReturnType<typeof getRequestStripeSubscriptions>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestStripeSubscriptionsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestStripeSubscriptions>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions = getGetRequestStripeSubscriptionsQueryOptions(
        params,
        options,
    )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * @summary Post Stripe Create Customer
 */
export const postRequestStripeCreateCustomer = (
    params: PostRequestStripeCreateCustomerParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<MessageResponseDTO>(
        { url: `/stripe/create_customer`, method: 'POST', params, signal },
        options,
    )
}

export const getPostRequestStripeCreateCustomerMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestStripeCreateCustomer>>,
        TError,
        { params: PostRequestStripeCreateCustomerParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestStripeCreateCustomer>>,
    TError,
    { params: PostRequestStripeCreateCustomerParams },
    TContext
> => {
    const mutationKey = ['postRequestStripeCreateCustomer']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestStripeCreateCustomer>>,
        { params: PostRequestStripeCreateCustomerParams }
    > = (props) => {
        const { params } = props ?? {}

        return postRequestStripeCreateCustomer(params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestStripeCreateCustomerMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestStripeCreateCustomer>>
>

export type PostRequestStripeCreateCustomerMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Post Stripe Create Customer
 */
export const usePostRequestStripeCreateCustomer = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestStripeCreateCustomer>>,
            TError,
            { params: PostRequestStripeCreateCustomerParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestStripeCreateCustomer>>,
    TError,
    { params: PostRequestStripeCreateCustomerParams },
    TContext
> => {
    const mutationOptions =
        getPostRequestStripeCreateCustomerMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
